import { L10n } from '../L10n/L10n';
import { IGroupBasicInfo } from '../models/IGroupInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Groups } from '../resources/Groups';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { DeleteGroupsActionNotification } from './GroupsActionNotification';

export class DeleteGroupAction {

  public static $inject = ['$translate',
                           'ConfirmActionDialog',
                           'DeleteGroupsActionNotification',
                           'Groups'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private deleteGroupsActionNotification: DeleteGroupsActionNotification,
    private Groups: Groups) { }

  public showDeleteGroupDialog(
    groups: Set<IGroupBasicInfo>,
    dialogScope: ng.IScope): ng.IPromise<any> {

    let dialogBody: string;
    let successMessage: string;

    if (groups.size() === 1) {
      const group = groups.first();
      dialogBody = this.$translate.instant('confirmDeleteGroup', { GROUP_NAME: L10n.elideIfLong(group.name) });
      successMessage = this.$translate.instant('groupDeleted', { GROUP_NAME: L10n.elideIfLong(group.name) });
    } else {
      dialogBody = this.$translate.instant('confirmDeleteGroups', { GROUP_COUNT: groups.size() }, L10n.Interpolations.Count);
      successMessage = this.$translate.instant('groupsDeleted', { GROUP_COUNT: groups.size() }, L10n.Interpolations.Count);
    }

    const dialogInstance = this.ConfirmActionDialog.open({
      scope: dialogScope,
      title: this.$translate.instant('deleteMessage'),
      bodyText: dialogBody,
      actionName: this.$translate.instant('confirmDeleteButton', { ITEM_COUNT: groups.size() }, L10n.Interpolations.Count),
      isDeleteAction: true,
      action: () => this.Groups.deleteGroups(groups.keys())
    });

    dialogInstance.result.then((result: IResult) => {
      this.deleteGroupsActionNotification.notify(result, groups);
    });

    return dialogInstance.result;
  }

  public showDeleteGroupsDialog(
    groups: Set<IGroupBasicInfo>): ng.IPromise<any> {

    let dialogBody: string;
    let successMessage: string;

    if (groups.size() === 1) {
      const group = groups.first();
      dialogBody = this.$translate.instant('confirmDeleteGroup', { GROUP_NAME: L10n.elideIfLong(group.name) });
      successMessage = this.$translate.instant('groupDeleted', { GROUP_NAME: L10n.elideIfLong(group.name) });
    } else {
      dialogBody = this.$translate.instant('confirmDeleteGroups', { GROUP_COUNT: groups.size() }, L10n.Interpolations.Count);
      successMessage = this.$translate.instant('groupsDeleted', { GROUP_COUNT: groups.size() }, L10n.Interpolations.Count);
    }

    const dialogInstance = this.ConfirmActionDialog.open({
      title: this.$translate.instant('deleteMessage'),
      bodyText: dialogBody,
      actionName: this.$translate.instant('confirmDeleteButton', { ITEM_COUNT: groups.size() }, L10n.Interpolations.Count),
      isDeleteAction: true,
      action: () => this.Groups.deleteGroups(groups.keys())
    });

    dialogInstance.result.then((result: IResult) => {
      this.deleteGroupsActionNotification.notify(result, groups);
    });

    return dialogInstance.result;
  }
}

Module.instance().service('DeleteGroupAction', DeleteGroupAction);
